import { RouteRecordRaw } from 'vue-router';

export const adminRoutes: Array<RouteRecordRaw> = [
    {
        path: 'users',
        name: 'usersAdmin',
        components: {
            default: () => import('@/views/admin/AdminUsersView.vue'),
        },
        meta: {
            headName: 'Users',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'groups',
        name: 'groupsAdmin',
        components: {
            default: () => import('@/views/admin/AdminGroupsView.vue'),
        },
        meta: {
            headName: 'Groups',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'research',
        name: 'researchAdmin',
        redirect: to => ({
            name: 'researchAdminContent',
            query: to.query,
            hash: to.hash,
        }),
        meta: {
            headName: 'Research',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'research/content',
        name: 'researchAdminContent',
        components: {
            default: () => import('@/views/admin/AdminResearchPortalView.vue'),
        },
        meta: {
            headName: 'Research',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'research/tags',
        name: 'researchAdminTags',
        components: {
            default: () => import('@/views/admin/AdminResearchPortalView.vue'),
        },
        meta: {
            headName: 'Research Tags',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'research/analysts',
        name: 'researchAdminAnalysts',
        components: {
            default: () => import('@/views/admin/AdminResearchPortalView.vue'),
        },
        meta: {
            headName: 'Research Analysts',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'research/access',
        name: 'researchAdminAccess',
        components: {
            default: () => import('@/views/admin/AdminResearchPortalView.vue'),
        },
        meta: {
            headName: 'Research Access',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'long-term-power',
        name: 'longTermPowerAdmin',
        components: {
            default: () => import('@/views/admin/AdminLongTermPower.vue'),
        },
        meta: {
            headName: 'Long Term Power',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'asset-tracking',
        name: 'assetTrackingAdmin',
        components: {
            default: () => import('@/views/admin/AdminAssetTrackingView.vue'),
        },
        meta: {
            headName: 'Asset Tracking',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'short-term-markets',
        name: 'shortTermMarketsAdmin',
        components: {
            default: () => import('@/views/admin/EnactAdminView.vue'),
        },
        meta: {
            headName: 'Short Term Markets',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'chatbot',
        name: 'chatBotAdmin',
        components: {
            default: () => import('@/views/admin/AdminChatBotView.vue'),
        },
        meta: {
            headName: 'ChatBot Admin',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
    {
        path: 'benchmarks',
        name: 'benchmarksAdmin',
        components: {
            default: () => import('@/views/admin/AdminBenchmarksView.vue'),
        },
        meta: {
            headName: 'Benchmarks Admin',
            accessName: 'admin',
            searchMeta: {
                isSiteAdmin: true,
            },
        },
    },
];
